import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ExtendedCalendarEventForScheduleFragment } from '../../services/full-calendar-helper.service';

@Component({
  selector: 'app-book-off-event',
  templateUrl: './book-off-event.component.html',
  styleUrls: ['./book-off-event.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class BookOffEventComponent {
  @Input() event: ExtendedCalendarEventForScheduleFragment;
  @Input() viewType: string;

  get isHidden() {
    return this.viewType === 'dayGridMonth';
  }
}
